import FlexPane from './_flex-pane.js'
import ImageButton from './_image-button.js'
import Tooltip from './_tooltip.js'

export default {
  name: 'NeutralVenueIndicator',
  values: {
    shouldShowTooltip: false,
    container: {
      configSet: FlexPane,
      configValues: {
        createStackingContext: true,
        style: {
          flexGrow: 0,
          flexShrink: 0,
          justifyContent: 'center',
        },
      },
    },
    icon: {
      configSet: ImageButton,
      configValues: {
        innerContainer: {
          style: {
            alignItems: 'center',
            justifyContent: 'center',
          },
        },
        buttonIcon: {
          src: 'system-neutralvenue',
          style: {
            alignSelf: 'center',
            width: '12px',
            height: '12px',
          },
        },
      },
    },
    tooltip: {
      configSet: Tooltip,
      configValues: {
        popup: {
          container: {
            style: {
              top: 'calc(100% + 8px)',
              width: 'max-content',
              minWidth: '220px',
            },
          },
          arrowhead: {
            direction: 'up',
          },
          arrowheadOffset: 'calc(50% - 8px)',
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
